__turbopack_context__.v({
  "body": "GlobalFeedbackDialog-module__GSf1yG__body",
  "detailsSection": "GlobalFeedbackDialog-module__GSf1yG__detailsSection",
  "topicChips": "GlobalFeedbackDialog-module__GSf1yG__topicChips",
  "topicSection": "GlobalFeedbackDialog-module__GSf1yG__topicSection",
});
